import PropTypes from 'prop-types'
import {Component} from 'react'
import * as uuid from 'uuid'

import * as ButtonTypes from '../../../../shared_components/ButtonTypes'
import Forms from '../../../../shared_components/forms'
import Modal from '../../../../shared_components/Modal'
import NewLoader from '../../../../shared_components/NewLoader'
import States from '../../../../lib/us-states-data.json'

export default class FirmForm extends Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedFirmType: props.firmType || 'firm'
    }

    this.submit = this.submit.bind(this)
    this.handleFirmTypeChange = this.handleFirmTypeChange.bind(this)
    this.organizationValidator = this.organizationValidator.bind(this)
  }

  handleFirmTypeChange(event) {
    const value = event.target.value
    // Map display values to actual keys
    const valueMap = {
      Firm: 'firm',
      'Funeral Home': 'funeral_home'
    }
    const newFirmType = valueMap[value] || value

    // Reset the organization_id when firm type changes
    this.refs.form.setFormValue('organization_id', '')

    this.setState({selectedFirmType: newFirmType})
  }

  organizationValidator(name, data) {
    // Only require organization if firm type is funeral_home
    if (this.state.selectedFirmType === 'funeral_home' && !data[name]) {
      return {
        name,
        errors: ['Organization is required for funeral homes.']
      }
    }
  }

  submit() {
    if (this.refs.form.validate().length === 0) {
      let formData = this.refs.form.formData()

      // Non UUID values should be uppercased to prevent casing issues when looking firms by external id
      if (Boolean(formData.external_id) && !uuid.validate(formData.external_id))
        formData = {...formData, external_id: formData.external_id.toUpperCase()}

      this.props.submit(formData)
    }
  }

  render() {
    return (
      <Modal closer={this.props.toggleModal} visible={this.props.showModal}>
        <div className='modal-header'>{this.props.modalheaderText}</div>
        <NewLoader loading={this.props.loadingOrganizations}>
          <Forms.Form ref='form' errors={[{name: 'firm_name', errors: this.props.errors}]}>
            <Forms.Input
              name='firm_name'
              label='Firm Name:'
              validator={Forms.Validators.required}
              defaultValue={this.props.firmName}
            />
            <Forms.Select
              defaultValue={this.props.firmType || 'firm'}
              name='firm_type'
              label='Firm Type'
              list={[{key: 'firm', value: 'Firm'}, {key: 'funeral_home', value: 'Funeral Home'}]}
              validator={Forms.Validators.required}
              onChange={this.handleFirmTypeChange}
            />
            <Forms.Select
              defaultValue={this.props.organizationId}
              name='organization_id'
              label='Organization'
              list={this.props.organizations.data
                .filter(organization => (organization['organization-type'] || organization.organization_type) === this.state.selectedFirmType)
                .map(organization => ({key: organization.id, value: organization.name}))}
              placeholder='No Organization'
              validator={this.organizationValidator}
            />
            <Forms.Input
              name='external_id'
              label='External ID'
              defaultValue={this.props.externalId}
            />
            <Forms.Input
              name='billing_address1'
              label='Address Line 1'
              defaultValue={this.props.billingAddress1}
            />
            <Forms.Input
              name='billing_address2'
              label='Address Line 2'
              defaultValue={this.props.billingAddress2}
            />
            <Forms.Input
              name='billing_city'
              label='City'
              defaultValue={this.props.billingCity}
            />
            <Forms.Select
              defaultValue={this.props.billingState}
              name='billing_state'
              label='State'
              list={States.map(state => ({key: state, value: state}))}
            />
            <Forms.Input
              name='billing_zip'
              label='Zip'
              defaultValue={this.props.billingZip}
            />
            <Forms.Input
              name='billing_phone'
              label='Phone'
              defaultValue={this.props.billingPhone}
            />
            <Forms.Input
              name='website'
              label='Website'
              defaultValue={this.props.website}
            />
            <Forms.Checkbox
              defaultValue={this.props.internal}
              label='Internal test firm'
              name='internal'
              className='internal'
              value={this.props.internal}
            />
          </Forms.Form>
        </NewLoader>
        <div className='button-group'>
          <ButtonTypes.Cancel onClick={this.props.closeModal} />
          <ButtonTypes.Continue loading={this.props.processing} onClick={this.submit}>{this.props.actionText}</ButtonTypes.Continue>
        </div>
      </Modal>
    )
  }
}

FirmForm.propTypes = {
  actionText: PropTypes.string,
  billingAddress1: PropTypes.string,
  billingAddress2: PropTypes.string,
  billingCity: PropTypes.string,
  billingPhone: PropTypes.string,
  billingState: PropTypes.string,
  billingZip: PropTypes.string,
  closeModal: PropTypes.func,
  errors: PropTypes.arrayOf(PropTypes.string),
  externalId: PropTypes.string,
  firmName: PropTypes.string,
  firmType: PropTypes.string,
  modalheaderText: PropTypes.string,
  internal: PropTypes.bool,
  loadingOrganizations: PropTypes.bool,
  organizations: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.object)
  }),
  organizationId: PropTypes.string,
  processing: PropTypes.bool,
  showModal: PropTypes.bool,
  submit: PropTypes.func,
  toggleModal: PropTypes.func,
  website: PropTypes.string
}

FirmForm.defaultProps = {
  modalheaderText: 'Add Firm'
}
